import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private baseUrl = `${this.appConfigService.CoreAPIUrl}/api`;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService) {
  }

  getProducts(searchTerm = null, minPrice = null, maxPrice = null, categories = null, brands = null, pageNo = 1) {
    let queryParam = searchTerm ? `searchTerm=${searchTerm}&` : '';
    queryParam += minPrice ? `minPrice=${minPrice}&` : '';
    queryParam += maxPrice ? `maxPrice=${maxPrice}&` : '';
    queryParam += categories ? `categories=${categories}&` : '';
    queryParam += brands ? `brands=${brands}&` : '';
    queryParam += pageNo ? `pageNo=${pageNo}` : '';
    return this.http.get<any>(`${this.baseUrl}/search/product?${queryParam}`);
  }

  getProductById(productId: number) {
    return this.http.get<any>(`${this.baseUrl}/${productId}`);
  }
}
